/**
 * legal-nav.js
 * ---------------------------------------------------------------------------
 * Pliega el menú de las páginas legales en móvil.
 *
 * El `<details>` sale con `open` desde el Liquid a propósito: si saliera
 * cerrado, sin JavaScript el menú quedaría escondido también en escritorio, que
 * es justo donde tiene que verse entero. Así que este script solo hace lo
 * contrario de lo habitual: cierra en pantallas estrechas y reabre al ensanchar.
 *
 * 768 px es el único punto de ruptura del tema.
 */
(() => {
  const DESKTOP = window.matchMedia('(min-width: 768px)');

  const sync = () => {
    document.querySelectorAll('.legal__nav').forEach((nav) => {
      nav.open = DESKTOP.matches;
    });
  };

  sync();
  DESKTOP.addEventListener('change', sync);
})();
